import React, { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { useTranslation } from "react-i18next";
import PrimaryButton from "../PrimaryButton/PrimaryButton";
import "./ParsedCommentsModal.css";

const ParsedCommentsModal = ({
  isOpen,
  comments = [],
  leftover = "",
  isSending = false,
  onConfirm,
  onSendAsOne,
  onClose,
}) => {
  const { t } = useTranslation();
  const modalRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === "Escape" && !isSending) onClose();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [isOpen, isSending, onClose]);

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="parsed-comments-overlay">
      <div
        className="parsed-comments-modal"
        ref={modalRef}
        role="dialog"
        aria-modal="true"
      >
        <button
          className="parsed-comments-close"
          onClick={onClose}
          disabled={isSending}
          aria-label={t("comments.parsed.close")}
        />

        <h2 className="parsed-comments-title">{t("comments.parsed.title")}</h2>

        <p className="parsed-comments-lead">
          {t("comments.parsed.body", { count: comments.length })}
        </p>

        <ul className="parsed-comments-list">
          {comments.map((item, index) => (
            <li
              className="parsed-comments-item"
              key={`${item.timecode}-${index}`}
            >
              <span className="parsed-comments-time">{item.timecode}</span>
              <span className="parsed-comments-text">{item.body}</span>
            </li>
          ))}
        </ul>

        {leftover && (
          <p className="parsed-comments-leftover">
            {t("comments.parsed.leftover")}
          </p>
        )}

        <div className="parsed-comments-actions">
          <button
            className="parsed-comments-cancel"
            onClick={onSendAsOne}
            disabled={isSending}
          >
            {t("comments.parsed.sendOne")}
          </button>
          <PrimaryButton
            isLoading={isSending}
            onClick={onConfirm}
            text={t("comments.parsed.sendSeparate")}
          />
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ParsedCommentsModal;
